// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9640) return "static/chunks/9640-2366523b9a4df3ab.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"337":"f54a0ea5d5449c4c","2875":"6d95cda3df23bcd0","4486":"88debe026ff40fb0"}[chunkId] + ".js";
};